import React from 'react';
import QuestionLabel from './QuestionLabel';
import { getOptionsFromList } from '../../../lib/Questions';

const DropdownQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            {settings?.options && (
                <select
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    className="w-full"
                >
                    <option value=""> </option>
                    {getOptionsFromList(settings.options).map((opt, idx) => (
                        <option value={opt} key={idx}>
                            {opt}
                        </option>
                    ))}
                </select>
            )}
        </label>
    );
};

export default DropdownQuestion;
